import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=596ac7dc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=596ac7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ac7dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596ac7dc')) {
      api.createRecord('596ac7dc', component.options)
    } else {
      api.reload('596ac7dc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=596ac7dc&scoped=true&", function () {
      api.rerender('596ac7dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28nSOcv14a224/JS/comp/SearchFilterTokens.vue"
export default component.exports